module.exports = __webpack_public_path__ + "img/sort-up-active.1b25dd41.svg";